import { Outlet } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import HamsterAnimation from "../animation/loader";

const ProtectedRoute = () => {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return <HamsterAnimation />;
  }

  if (!isAuthenticated) {
    loginWithRedirect();
    return null;
    
  }

  return <Outlet />;
};

export default ProtectedRoute;
